import { useQuery } from "@tanstack/react-query";
import { api, toQueryString } from "@/lib/api";

/**
 * Which quarter and year a date implies — **asked of the server**.
 *
 * Derivation is server-side, always: this endpoint answers with the same `extract()` the
 * generated columns use, so a preview cannot disagree with what saving will store. Two
 * lines of browser arithmetic would be a defect, not a shortcut.
 *
 * Shared by the board's date dialogs and the detail's inline date field, because the
 * alternative — the same query written twice — is how one surface's preview starts
 * disagreeing with the other's.
 */
export function useQuarterPreview(date: string) {
  return useQuery({
    queryKey: ["close-date-preview", date],
    queryFn: () =>
      api.get<{ quarter: number; year: number }>(`/opportunities/close-date-preview${toQueryString({ date })}`),
    // Nothing is asked for a half-typed date, and the answer for a given date never changes.
    enabled: /^\d{4}-\d{2}-\d{2}$/.test(date),
    staleTime: Infinity,
  });
}
